module.exports = "/_next/static/images/08ff48c64468746fc457cf135e5c620e-hero-md.jpg";